import Draggable, {DraggableData} from "react-draggable";
import styled from "styled-components";
import {Dispatch, SetStateAction, useEffect, useState} from "react";

interface DevicePointProps {
    imageSize: {
        width: number;
        height: number;
    };
    setFormattedPosition: Dispatch<SetStateAction<{left: number; top: number}>>;
}

const DevicePoint = (props: DevicePointProps) => {
    const [position, setPosition] = useState<{x: number; y: number}>({
        x: 0,
        y: 0,
    });

    const handleOnDrag = (data: DraggableData) => {
        setPosition({x: data.x, y: data.y}); // 드래그를 하는 동안 컴포넌트의 위치를 업데이트 해준다.
    };

    useEffect(() => {
        if (props.imageSize.width && props.imageSize.height && position.x && position.y)
            props.setFormattedPosition({
                left: Number(((position.x / props.imageSize.width) * 100).toFixed(1)),
                top: Number(((position.y / props.imageSize.height) * 100).toFixed(1)),
            });
    }, [props.imageSize, position]);

    return (
        <Draggable position={{x: position.x, y: position.y}} onDrag={(_, data) => handleOnDrag(data)} bounds={"parent"}>
            <Container>
                <Pointer />
            </Container>
        </Draggable>
    );
};

export {DevicePoint};

const Container = styled.div`
    width: 0;
    height: 0;
    position: absolute;
    top: 0;
    left: 0;
`;

const Pointer = styled.div`
    width: 30px;
    height: 23px;
    padding: 0 6px;
    background-color: red;
    cursor: pointer;

    &:hover {
        box-shadow: 0 0 5px gray;
    }
`;
